import React, { useRef, useState } from 'react';
import { Col, Form, Row, } from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik, } from 'formik';
import * as Yup from 'yup';
import { useReactToPrint } from 'react-to-print';
import { FaDownload, FaPrint } from 'react-icons/fa';
import moment from 'moment';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import { InfoAlert } from '../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { CommonAxiosGet } from '../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading';
import { ACADEMIC_YEAR, CONTEXT_NAME } from '../../CommonUtilities/Validations/RegularExpAndVar';

export const Afterprint = () =>
    <div id='afterprint'>
        <div className='print-page-heading'>
            <h3>{CONTEXT_NAME} - {ACADEMIC_YEAR}</h3>
            <h5>GOVERNMENT OF ANDHRA PRADESH</h5>
        </div>
    </div>
export const PersonalDetails = (props) => {
    const { showData } = props;
    return (<>
        <div className='personal-block'>
            <div className="personal-head"> <span>Personal Details</span>
            </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped" style={{ tableLayout: 'fixed' }}>
                        <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                            <tr>
                                <td style={{ width: '15%' }}>Candidate Id </td>
                                <th style={{ width: '20%' }}>{showData?.candidate_id}</th>
                                <td style={{ width: '15%' }}>Aadhaar No. </td>
                                <th style={{ width: '20%' }}>{showData?.aadhaar_no}</th>
                                <td rowSpan={4} className="" style={{ width: '30%' }}>
                                    <img src={showData?.img_path ? config.url.FILE_DOWNLOAD_URL + showData?.img_path : '#'}
                                        className='img-fluid'
                                        alt="studentphoto"
                                        style={{
                                            width: "130px",
                                            height: "150px",
                                            display: "block",
                                            margin: "0 auto",
                                            border: "1px solid #ddd"
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Applicant Name</td>
                                <th>{showData?.applicant_name}</th>
                                <td>Mobile No.</td>
                                <th>{showData?.mobile_no}</th>
                            </tr>
                            <tr>
                                <td>Application Date </td>
                                <th>{showData?.last_applied_on ? showData?.last_applied_on : showData?.appl_confirmed_on ? showData?.appl_confirmed_on : '-'}</th>
                                <td>Date of Birth (DD/MM/YYYY)</td>
                                <th>{moment(showData?.dob).format('DD-MM-YYYY')}</th>
                            </tr>
                            <tr>
                                <td>Father's Name</td>
                                <th>{showData?.father_name}</th>
                                <td>Mother's Name</td>
                                <th>{showData?.mother_name}</th>
                            </tr>
                            <tr>
                                <td>Gender</td>
                                <th>{showData?.gender}, {showData?.marital_status}</th>
                                <td>Caste</td>
                                <th colSpan={2}>{showData?.caste}, &nbsp;
                                    {showData?.is_ews === true && showData?.caste === 'OC' ? "Eligible for (EWS)" : "Not Eligible for (EWS)"}
                                </th>
                            </tr>
                            <tr> <td>Ex-Service Woman</td>
                                <th>{showData?.is_ex_service_men === true ? <>Yes ,{showData?.ex_service}</> : "No"}</th>
                                <td>E-mail</td>
                                <th colSpan={2}>{showData?.email}</th>
                            </tr>
                            <tr>
                                <td>If Differently Abled(PH)</td>
                                <th colSpan={4}>{showData?.is_ph === true ? <React.Fragment>
                                    {showData?.is_vh === true && <React.Fragment>VISUALLY IMPAIRED(VI)  - {showData?.vh_percentage}%</React.Fragment>}<br />
                                    {showData?.is_hi === true && <React.Fragment>HEARING IMPAIRED(HI)  - {showData?.hi_percentage}%</React.Fragment>}<br />
                                    {showData?.is_oh === true && <React.Fragment>ORTHOPEDICALLY HANDICAPPED(OH)  - {showData?.oh_percentage}%</React.Fragment>}<br />
                                    {showData?.is_mi === true && <React.Fragment>MENTAL DISABILITY / MULTIPLE DISABILITY(MD)  : {showData?.mi_percentage}%</React.Fragment>}

                                 
                                </React.Fragment> : 'No'}
                                </th>
                            </tr>
                            <tr>
                                <td>Communication Details</td>
                                <th colSpan={4}>{showData?.is_andhra === true ? <React.Fragment>
                                    {showData?.address}, Door No.{showData?.door_no},&nbsp;
                                    {showData?.village_name} {showData?.mandal_name}-{showData?.pin_code},&nbsp;
                                    {showData?.dist_name} dist.
                                </React.Fragment> :
                                    <React.Fragment>
                                        {showData?.address}, Door No.{showData?.door_no},&nbsp;
                                        {showData?.mandal_name} - {showData?.pin_code},&nbsp;
                                        {showData?.dist_name} dist., {showData?.state_name}
                                    </React.Fragment>}</th>
                              

                            </tr>
                            {/* <tr>
                                    <td colSpan={3}>Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014 <br />and are you claiming under the G.O MS No 133:</td>
                                    <th colSpan={2}>{showData?.is_telangana === true ? <React.Fragment>Yes, {showData?.claiming_district_name} District.</React.Fragment> : 'No'} </th>
                                </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
    </>)
}
export const SevenYearDetails = (props) => {
    const { showSevenData,showData } = props;
    return (<> 
    <div className='personal-block'>
        <div className="personal-head">
            <span>Basic Education Details</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive">
                <table className="table table-bordered table-striped"
                    style={{
                        borderCollapse: 'collapse',
                        width: '100%',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                            <th style={{ width: '25%' }}>District</th>
                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                            <th style={{ width: '25%' }}>District</th>
                        </tr>
                        <tr>
                            <td>{showSevenData[0]?.class_no}<sup>Th</sup>Class </td>
                            <td>{showSevenData[0]?.dist_name}</td>
                            <td>{showSevenData[1]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[1]?.dist_name}</td>
                        </tr>
                        <tr>
                            <td>{showSevenData[2]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[2]?.dist_name}</td>
                            <td>{showSevenData[3]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[3]?.dist_name}</td>
                        </tr>
                        <tr>
                            <td>{showSevenData[4]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[4]?.dist_name}</td>
                            <td>{showSevenData[5]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[5]?.dist_name}</td>
                        </tr>

                        <tr>
                            <td>{showSevenData[6]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[6]?.dist_name}</td>
                            <td colSpan={2}></td>
                        </tr>
                        {showData?.is_telangana === true && <tr><td colSpan={2}>Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014
                            and are you claiming under the G.O MS No 133:</td>
                            <th>{showData?.is_telangana === true ? <React.Fragment>Yes.</React.Fragment> : 'No'}</th></tr>
                        }
                        <tr><td>Local District</td>
                            <th colSpan={3}>{showData?.is_telangana === true ? showData?.claiming_district_name : showData?.local_dist_name}</th></tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </>)
}
export const SSCDetails = (props) => {
    const { showSSCInterData } = props;
    return (<>  
    <div className='personal-block'>
        <div className="personal-head">
            <span>SSC or its Equivalent Qualifications:</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive">
                <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th>Board</th>
                            <th>Medium</th>
                            <th>1st Language</th>
                            <th>Year of Passing</th>
                            <th>Total Marks</th>
                            <th>Marks Secured</th>
                            <th>% of Marks</th>
                            <th>Hall Ticket No.</th>
                            <th>Did you studied English ?</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>{showSSCInterData?.ssc_board_name}</td>
                            <td>{showSSCInterData?.ssc_medium_name}</td>
                            <td>{showSSCInterData?.ssc_first_language_name}</td>
                            <td>{showSSCInterData?.ssc_year_of_pass}</td>
                            <td>{showSSCInterData?.ssc_total_marks}</td>
                            <td>{showSSCInterData?.ssc_marks_secured}</td>  
                            <td>{showSSCInterData?.ssc_percentage}</td>
                            <td>{showSSCInterData?.ssc_hall_ticket}</td>
                            <td>{showSSCInterData?.is_english_ssc}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div className="page-break"></div>
    </>)
}
export const INTERDetails = (props) => {
    const { showSSCInterData } = props;
    return (<> 
    <div className='personal-block personal-block1'>
        <div className="personal-head">
            <span>Intermediate or its Equivalent Qualification:</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive">
                <table className="table table-bordered table-striped"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    {showSSCInterData ? <>

                        {/* <tbody> */}
                         <thead>
                            <tr>
                                <th>Course</th>
                                <th>Subject 1</th>
                                <th>Subject 2</th>
                                <th>Subject 3</th>
                                <th colSpan={5}>Subject 4</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{showSSCInterData?.inter_course}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_1_name || "-"}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_2_name || "-"}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_3_name || "-"}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }} colSpan={5}>{showSSCInterData?.inter_subject_4_name|| "-"}</td></tr></tbody>
 <thead>
                            <tr>
                                <th>Board</th>
                                <th>Medium</th>
                                <th>2nd Language</th>
                                <th>Year of Passing</th>
                                <th>Hall Ticket No.</th>
                                <th>Total Marks</th> 
                                <th>Marks Secured</th>
                                <th>% of Marks</th>
                                 <th>Did you studied English ?</th>
                            </tr></thead>
                            <tbody>
                            <tr><td>{showSSCInterData?.inter_board_name}</td>
                                <td>{showSSCInterData?.inter_medium_name}</td>
                                <td>{showSSCInterData?.inter_second_language_name}</td>
                                <td>{showSSCInterData?.inter_year_of_pass}</td>
                                <td>{showSSCInterData?.inter_hall_ticket}</td>
                                <td>{showSSCInterData?.inter_total_marks}</td>
                                <td>{showSSCInterData?.inter_marks_secured}</td>

                                <td>{showSSCInterData?.inter_percentage}</td>
                                <td>{showSSCInterData?.is_english_inter}</td>
                            </tr>

                        </tbody>
                    </>

                        : 'You have not selected any degree'}

                </table>
            </div>
        </div>
    </div>
    </>)
}
export const UGDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<>
    <div className='personal-block'>
        {showUgPgPqData?.filter((val) => val.study_type === "UG")?.length > 0 ?
            <div className='personal-block'>
                <div className="personal-head">
                    <span>Degree or its Equivalent Qualification:</span>
                </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped"
                            style={{ borderCollapse: 'collapse' }}>
                            {showUgPgPqData?.filter((val) => val.study_type === "UG")?.map((item, i) => {
                                return (
                                    <tbody key={i}>
                                        <tr>
                                            <th colSpan={2}>Course</th><th colSpan={2}>Subject 1</th>
                                            <th colSpan={2}>Subject 2</th>
                                            <th>Subject 3</th><th colSpan={2}>Subject 4</th>
                                        </tr>
                                        <tr><td colSpan={2}>{item?.course_name}</td>
                                            <td colSpan={2}>{item?.subject_1_name || "-"}</td>
                                            <td colSpan={2}>{item?.subject_2_name || "-"}</td>
                                            <td >{item?.subject_3_name || "-"}</td>
                                            <td colSpan={2}>{item?.subject_4_name || "-"}</td></tr>
                                        <tr>
                                            <th>University</th>
                                            <th>Medium</th>
                                            <th>2nd Language</th>
                                            <th>Year of Passing</th>
                                            <th>Hall Ticket No.</th>
                                                <th>Total Marks</th>
                                                <th>Marks Secured</th>
                                            <th>% of Marks</th>
                                             <th>Did You Study English?</th>
                                        </tr>
                                        <tr><td>{item?.univ_name}</td>
                                            <td>{item?.medium_name}</td>
                                            <td>{item?.second_language_name}</td>
                                            <td>{item?.year_of_pass}</td>
                                            <td>{item?.hall_ticket}</td>
                                            <td>{item?.total_marks}</td>
                                            <td>{item?.marks_secured}</td>
                                            <td>{item?.percentage}</td>
                                            <td>{item?.is_english_ug}</td>
                                        </tr>
                                    </tbody>
                                )
                            })}
                        </table>
                    </div>
                </div>
            </div>
            : <></>}
    </div>
    </>)
}
export const PGDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<>   
    <div className='personal-block'>
        {showUgPgPqData?.filter((val) => val.study_type === "PG")?.length > 0 ? <div className='personal-block'>
            <div className="personal-head">
                <span>Post Graduation</span>
            </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive" >
                    <table className="table table-bordered table-striped"
                        style={{ borderCollapse: 'collapse', }} role="presentation">

                        {showUgPgPqData?.filter((val) => val.study_type === "PG")?.map((item, i) => {
                            return (
                                <tbody key={i}>
                                    <tr>
                                        <th>Course</th>
                                        <th colSpan={6}> Subject</th>
                                    </tr>
                                    <tr> <td>{item?.course_name}</td>
                                        <td colSpan={6}>{item?.subject_1_name}</td></tr>
                                    <tr>
                                        <th>University</th>
                                        <th>Medium</th>
                                        <th>Year of Passing</th>
                                        <th>Hall Ticket No.</th>
                                        <th>Total Marks</th>
                                        <th>Marks Secured</th>
                                        <th>% of Marks</th>
                                    </tr>
                                    <tr><td>{item?.univ_name}</td>
                                        <td>{item?.medium_name}</td>
                                        <td>{item?.year_of_pass}</td>
                                        <td>{item?.hall_ticket}</td>
                                        <td>{item?.total_marks}</td>
                                        <td>{item?.marks_secured}</td>
                                        <td>{item?.percentage}</td>
                                    </tr>
                                </tbody>

                            )
                        })}

                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>
    </>)
}
export const PQDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<> 
    
    <div className='personal-block'>
     {showUgPgPqData?.filter((val) => val.study_type === "PQ")?.length > 0 ? <>
        <div className="personal-head">
            <span>Professional Qualification</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive" >
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    <thead>
                        <tr>
                            <th>Qualification</th>
                            <th> Methodology 1</th>
                            <th> Methodology 2</th>
                            <th>University</th>
                            <th>Medium</th>
                            <th> Year of Passing</th>
                            <th>Total Marks</th>
                            <th>Marks Secured</th>
                            <th>% of Marks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {showUgPgPqData?.filter((val) => val.study_type === "PQ")?.map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td>{item?.course_name}</td>
                                    <td>{item?.subject_1_name}</td>
                                    <td>{item?.subject_2_name}</td>
                                    <td>{item?.univ_name}</td>
                                    <td>{item?.medium_name}</td>
                                    <td>{item?.year_of_pass}</td>
                                    <td>{item?.total_marks}</td>
                                    <td>{item?.marks_secured}</td>
                                    <td>{item?.percentage}</td>
                                </tr>
                            )
                        })}
                        
                    </tbody>
                </table>
            </div>
        </div> </>: <></>}
    </div>
    {/* <div className="page-break"></div> */}
   
    </>)
}
export const TETDetails = (props) => {
    const { showTETData } = props;
    return (<> 
    <div className='personal-block personal-block2'>
        {showTETData?.length > 0 ? <div className='personal-block'><div className="personal-head">
            <span>APTET/CENTRAL TET DETAILS (CTET)</span>
        </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive">
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                        style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th>Tet Type</th>
                                <th>HallTicket No.</th>
                                <th>Paper</th>
                                <th>Name In TET</th>
                                <th>Year of Passing</th>
                                <th>Marks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showTETData?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item?.tet_type}</td>
                                        <td>{item?.hall_ticket}</td>
                                        <td>{item?.paper_name}</td>
                                        <td>{item?.name_in_tet}</td>
                                        <td>{item?.year_of_pass}</td>
                                        <td>{item?.marks}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>

    </>)
}
export const PrincipalDetails = (props) => {
    const { showData } = props;
    return (
    <div className='personal-block'>
        {(showData?.is_principal || showData?.is_hm || showData?.is_group_b) && (<div className='mt-2'>
            <div className="personal-head"><span>Experience for the post of principal</span> </div>
            <div className="personal-row mb-2">
                <table className="mb-2">
                    <tbody>
                        {showData?.is_principal && (<tr>
                            <td style={{ fontSize: "13px" }}>&bull;
                                You are holding the post of Principal or Vice-Principal
                                in the recognized senior secondary schools / equivalent
                                institutions dealing with English Medium in the pay scale of Rs.61960-151370 and with a minimum
                                service of 3 years from the date of notification issued.
                            </td>
                        </tr>)}
                        {showData?.is_group_b && (
                            <tr>
                                <td style={{ fontSize: "13px" }}>&bull;
                                    You are holding Group 'B' posts / the post of PGTs (or)
                                    Lecturers in the recognized senior secondary schools /
                                    equivalent institutions dealing with English Medium in the pay scale of Rs.48440-137220 and with a
                                    minimum service of 5 years from the date of notification issued.
                                </td>
                            </tr>)}
                        {showData?.is_hm && (
                            <tr>
                                <td style={{ fontSize: "13px" }}>&bull;
                                    You are Headmasters in the recognized secondary schools /
                                    equivalent institutions dealing with English Medium in the pay scale of Rs.44570-127480 and with a
                                    minimum service of 5 years from the date of notification issued.

                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>)}
    </div>)
}
export const PostDetails = (props) => {
    const { postDataLoadLess } = props;
    return (
    <div className='personal-block'>
        <div className="personal-head">
            <span>Posts Details</span>
        </div>

        <div className="personal-row personal-roweducation">
            <div className="table-responsive" >
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    <tbody>
                        <tr><th>S.No</th>
                            <th>Post</th>
                            <th>Applied On</th>
                        </tr>
                        {postDataLoadLess.length > 0 ? postDataLoadLess?.map((data, index) => {
                            return (
                                <tr key={index} id={index}>
                                    <td>{index + 1}.</td>
                                    <td>{data?.post_name}</td>
                                    <td>{data?.formatted_time_stamp}</td>
                                </tr>
                            )
                        }) :
                            <tr><td colSpan={4} className='text-center'><b className='text-danger'> *** You have not selected any posts</b></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>)
}

export const PaymentDetails = (props) => {
    const { PaymentData  } = props;
    return (
       <div className='personal-block'>
                <div className="personal-head">
                    <span>Payment Details:</span>
                </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped"
                            style={{ borderCollapse: 'collapse', }} role="presentation">

                            {PaymentData ? <>

                                <thead>
                                     <tr>
                                <th style={{ width: "5%" }}>S.NO</th>
                                <th style={{ width: "15%" }}>Candidate Id</th>
                                <th style={{ width: "25%" }}>Candidate Name</th>
                                <th style={{ width: "15%" }}>Transaction Id</th>
                                <th style={{ width: "15%" }}>CFSS Transaction Id</th>
                                <th style={{ width: "10%" }}>Paid Amount</th>
                                <th style={{ width: "10%" }}>Paid Date</th>
                                <th style={{ width: "10%" }}>Payment Status</th>
                            </tr>
</thead>
<tbody>
                            {PaymentData?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.candidate_id}</td>
                                    <td>{item.applicant_name}</td>
                                    <td>{item.tpsl_txn_id}</td>
                                    <td>{item.cfss_txn_id}</td>
                                    <td>{item.amount}</td>
                                    <td>{new Date(item.time_stamp).toLocaleString()}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))}
                             </tbody>
                            </>
                              : 'Payment not successful'}
                        </table>
                    </div>
                </div>
            </div>
        )
}
export const ExamCenterDetails = (props) => {
    const { examCenterData } = props;
    return (
        <div className='personal-block'>
            {examCenterData?.length > 0 ? <div className='personal-block'><div className="personal-head">
                <span>Examination  Center Preferred Places</span>
            </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive" >
                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                            style={{ borderCollapse: 'collapse', }} role="presentation">

                            <tbody>
                                <tr>
                                    <th>Preference Order</th>
                                    <th>Exam Centers</th>
                                </tr>
                                {examCenterData ? examCenterData?.map((item, index) => {
                                    return (
                                        <tr key={index} id={index}>
                                            <td>{item?.preference}.</td>
                                            <td>{item?.district}</td>
                                        </tr>
                                    )
                                }) : 'You have not selected any posts'}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <></>}
        </div>)
}
export const PreferncesDetails = (props) => {
    const { OptionList } = props;
    return (
        <>
    <div className='personal-block'>
        {OptionList?.length > 0 ? <div className='personal-block'><div className="personal-head">
            <span>Post Preferences</span>
        </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive" >
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                        style={{ borderCollapse: 'collapse', }} role="presentation">

                        <thead>
                            <tr>
                                <th>Preference Order</th>
                                <th>Post Name : Management Name @ District</th>
                            </tr>
                            </thead>
                            <tbody>
                            {OptionList ? OptionList?.map((val, i) => {
                                return (
                                    <tr key={val.id} id={i}>
                                        <td className='text-center'>{i + 1}</td>
                                        <td><b><span style={{ color: 'brown', fontFamily: 'Bold italic' }}>
                                            {val.management_name?.split('_')[0]} </span>: {val.management_name?.split('_')[1]}
                                            @ <span style={{ color: 'blue' }}>{val.management_name?.split('_')[2]}</span></b></td>
                                    </tr>
                                    
                                )
                            }) : 'You have not selected any posts'}
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>
    </>
    )
}

export default function CandidateDetailsReport() {
    const [showData, setData] = useState([])
    const [showSevenData, setSevenData] = useState([])
    const [showSSCInterData, setSSCInterData] = useState([]);
    const [showUgPgPqData, setUgPgPqData] = useState([]);
    const [showTETData, setTETData] = useState([]);
    const [postDataLoadLess, setPostDataLoadLess] = useState([]);
    const [examCenterData, setExamCenterData] = useState([]);
    const [OptionList, SetOptionList] = useState([])
    const [showPrintData, setPrintData] = useState(false)
    console.log("showPrintData", showPrintData)
    const candidateFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            candidateId: "",
        },
        validationSchema: Yup.object().shape({
            candidateId: Yup.string().required("Required"),
        }),
        onSubmit: (values) => {
            getCandidateData(values?.candidateId)
        }
    });
    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
         documentTitle: "DSC- Application Print",
        pageStyle: `
        @media print {
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                font-size: 12px;
            }
            table {
                width: 100% !important;
                table-layout: fixed !important;
                border-collapse: collapse !important;
                page-break-inside: avoid;
                margin-bottom: 15px !important;
            }
            th, td {
                padding: 6px !important;
                border: 1px solid #ddd !important;
                word-wrap: break-word;
                vertical-align: top;
            }
            th {
                background-color: #f2f2f2 !important;
                font-weight: bold;
                }
                  .personal-head span {
                  background-color: #ececec !important;
                  color: #000 !important;
                    }
                  .personal-block{
                    page-break-inside: avoid !important;
                  }
            .personal-head {
               
                padding: 8px !important;
                margin-top: 15px !important;
                margin-bottom: 10px !important;
                font-weight: bold;
            }
            img {
                max-width: 130px !important;
                max-height: 150px !important;
                display: block !important;
                margin: 0 auto !important;
            }
            .photo-cell {
                width: 150px !important;
                text-align: center !important;
                vertical-align: middle !important;
            }
        }
    `
    });
    const [htData, setHtData] = useState([]);
    const [PaymentData, setPaymentData] = useState()
    const [htFile, setHtFile] = useState()
    function getCandidateData(candidateId) {
        let Url = config.url.CONTEXT_READ_URL + "kgbv-print-application/candidate?candidateId=" + candidateId
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                setPrintData(true);
                setUgPgPqData(res?.data?.ugpgpq_status === true ? res?.data?.ugpgpq : []);
                setSevenData(res?.data?.sevenyear_status === true ? res?.data?.sevenyear : []);
                setSSCInterData(res?.data?.sscinter_status === true ? res?.data?.sscinter[0] : []);
                setTETData(res?.data?.tet_status === true ? res?.data?.tet : []);
                setExamCenterData(res?.data.examcenterdetails_status === true ? res.data.examcenterdetails : [])
                setPostDataLoadLess(res?.data?.postDetails_status === true ? res?.data?.postDetails : [])
                setHtFile(res?.data?.htFile_status ? res?.data?.htFile[0]?.hallticket_path : '')
                setHtData(res?.data?.htDetails_status ? res?.data?.htDetails : [])
                 setPaymentData(res?.data?.paymentDetails_status ? res?.data?.paymentDetails : [])
                // setPaymentData(res?.data?.payments_status ? res?.data?.payments[0] : {})
                // if (res?.data?.candidatepostpreferences_status === true) {
                //     let data_s = res?.data?.candidatepostpreferences;
                //     data_s?.forEach((data) => {
                //         data.id = `${data?.management_id}999${data?.post_id}`;
                //     });
                //     SetOptionList(data_s)
                // } else {
                //     SetOptionList([])
                // }

                if (res?.data?.candidatereg_status === true) {
                    setData(res?.data?.candidatereg[0])
                    localStorage.setItem("caste", res?.data?.candidatereg[0]?.certificate_id)
                    const casteId = res?.data?.candidatereg[0]?.certificate_id;
                    if (casteId) {
                        localStorage.setItem("caste", casteId);
                    } else {
                        console.warn("No certificate_id found");
                    }}}
            else {
                InfoAlert(res?.data?.sdesc, "Info")
                setPrintData(false); setSevenData([]); setUgPgPqData([]); setSSCInterData([]);
                setHtData([]); setTETData([]); SetOptionList([]); setExamCenterData([]); setPostDataLoadLess([]);
                setData([]);
            }
        })
    }
console.log("componentRef.current",componentRef.current);
console.log("componentRef.current.innerText",componentRef.current?.innerText);
console.log("componentRef.current?.innerText",componentRef.current?.innerText);
    return (
        <React.Fragment>
            <CommonPageHeading heading="Candidate Details" back={false} />
            <FormikProvider value={candidateFormik}>
                <Form className="form-section" onSubmit={candidateFormik.handleSubmit} onChange={candidateFormik.handleChange}>
                    <Row className="row">
                        <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-3">
                            <Form.Group controlId="aadhaarNo" >
                                <Form.Label className="input-lable mb-2">Candidate ID / Aadhaar Number /Mobile Number <font color="red">*</font></Form.Label>
                                <Field type="text" className="form-control" name="candidateId" maxLength="12"
                                    onChange={(e) => {
                                        setPrintData(false);
                                         setSevenData([]); setUgPgPqData([]); setSSCInterData([]); setHtData([]);
                                        setTETData([]); SetOptionList([]); setExamCenterData([]); setPostDataLoadLess([]); setData([]);

                                    }} />
                                <ErrorMessage component="div" className="text-danger" name="candidateId" />
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="">
                            <button type="submit" className='btn btn-success mt-4'>Get Details</button>
                        </Col>
                        {showPrintData && <>
                            <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mt-4">
                                {/* <button onClick={() => { handleprint() }} className="btn btn-primary me-4" variant="primary">Print Application &nbsp;
                                    <FaPrint title="Print" style={{ fontSize: '20px' }} />
                                </button> */}
                                <button
    type="button"
    onClick={handleprint}
    className="btn btn-primary me-4"
>
    Print Application &nbsp;
    <FaPrint title="Print" style={{ fontSize: '20px' }} />
</button>
                            </Col></>}
                        {/* {htData?.length > 0 && <>
                            <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mt-4">
                                <HallTicketFinal Hdata={htData} /></Col></>}
                        {htFile && <>
                            <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mt-4">
                                <a href={config.url.FILE_DOWNLOAD_URL + htFile} className='btn btn-secondary'><FaDownload /> HallTicket</a>
                            </Col></>} */}
                    </Row>
                    <React.Fragment>
                        {showPrintData && <div ref={componentRef}>
                        <DscPrintContent showData={showData} showSevenData={showSevenData} OptionList={OptionList} componentRef={componentRef} 
                        showUgPgPqData={showUgPgPqData} PaymentData={PaymentData} htData={htData} showSSCInterData={showSSCInterData} showTETData={showTETData} 
                        postDataLoadLess={postDataLoadLess} examCenterData={examCenterData} /></div>}
                    </React.Fragment>
                </Form>
            </FormikProvider>
        </React.Fragment>
    );
}

export const DscPrintContent = (props) => {
    const { showData, showSevenData, OptionList, componentRef, showUgPgPqData, PaymentData, htData, showSSCInterData, showTETData, postDataLoadLess, examCenterData } = props;
    // console.log("componentRef bhanu", componentRef)
    return (
        <div className='mt-1'>

            <Afterprint/>
            {/* <PrintPersonalContent showData={showData} />
            <PrintSevenStudy showData={showData} showSevenData={showSevenData} />
            <PrintSSCContent showData={showData} showSSCInterData={showSSCInterData} />
            <PrintInterContent showData={showData} showSSCInterData={showSSCInterData} />
            <PrintUGContent showData={showData} showUgPgPqData={showUgPgPqData} />
            <PrintPGContent showData={showData} showUgPgPqData={showUgPgPqData} />
            <PrintPQContent showData={showData} showUgPgPqData={showUgPgPqData} />
            <PrintPricipalContent showData={showData} />
            <PrintTETContent showTETData={showTETData} />
            <PrintPostContent showData={showData} postDataLoadLess={postDataLoadLess} />
            <PrintPreferenceContent showData={showData} OptionList={OptionList} />
            <PrintPaymentContent showData={showData} PaymentData={PaymentData} flag='DSC' />
            <PrintHallTicketContent showData={showData} htData={htData} /> */}
             <PersonalDetails showData={showData} />
            <SevenYearDetails showData={showData} showSevenData={showSevenData} />
            <SSCDetails showSSCInterData={showSSCInterData} />
            <INTERDetails showSSCInterData={showSSCInterData} />
            <UGDetails showUgPgPqData={showUgPgPqData} />
            <PGDetails showUgPgPqData={showUgPgPqData} />
            <PQDetails showUgPgPqData={showUgPgPqData} />
            <TETDetails showTETData={showTETData} />
            <PrincipalDetails showData={showData} />
            <PostDetails postDataLoadLess={postDataLoadLess} />
            <PaymentDetails PaymentData={PaymentData} />
            <ExamCenterDetails examCenterData={examCenterData} />
            <PreferncesDetails OptionList={OptionList} />
        </div>
        )
}
